// extracted by mini-css-extract-plugin
export var contentMarginBottom16 = "index-module--contentMarginBottom16--Vtvq8";
export var contentMarginBottom32 = "index-module--contentMarginBottom32--2fE56";
export var contentText = "index-module--contentText--Ly+Yy";
export var contentTitle = "index-module--contentTitle--FaarN";
export var smallTitle = "index-module--smallTitle--lHlF0";
export var smallTitleText = "index-module--smallTitleText--0QVVB";